const dialogId = 'twoClickDialog';
export const setupDialogListeners = (myDialogId) => {
    const dialogs = document.querySelectorAll('dialog');
    dialogs.forEach((dialog) => {
        dialog.addEventListener('close', () => {
            updateScroll(myDialogId);
        });
        dialog.addEventListener('cancel', () => {
            updateScroll(myDialogId);
        });
        dialog.addEventListener('show', () => {
            updateScroll(myDialogId);
        });
    });
};
const updateScroll = (myModalId) => {
    if (!otherModalsAreOpen(myModalId)) {
        scrollControl.restoreScrollPosition();
        document.body.style.overflow = 'auto';
        document.body.style.position = 'unset';
    }
    else {
        scrollControl.lockScrollPosition();
    }
};
export const opneCloseModal = (modal, consent) => {
    if (consent) {
        modal === null || modal === void 0 ? void 0 : modal.close();
    }
    else {
        modal === null || modal === void 0 ? void 0 : modal.show();
    }
    if (typeof document !== 'undefined') {
        updateScroll(dialogId);
    }
};
const scrollControl = {
    lockScrollPosition() {
        const { scrollY } = window;
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollY}px`;
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.dataset.scrollY = scrollY.toString();
    },
    restoreScrollPosition() {
        const { scrollY } = document.body.dataset;
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        window.scrollTo(0, parseInt(scrollY || '0', 10));
        delete document.body.dataset.scrollY;
    },
};
const otherModalsAreOpen = (myModalId) => {
    const dialogs = document.querySelectorAll('dialog[open]');
    return Array.from(dialogs).some((d) => d.id !== myModalId);
};
